import React from 'react';
import { TextField, Checkbox, FormControlLabel, Grid, MenuItem } from '@mui/material';

const ComplianceVerification = ({ formData, setFormData }) => {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.checked });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="PAN Card/Aadhaar Number"
          name="panAadhaar"
          value={formData.panAadhaar || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              name="backgroundVerificationConsent"
              checked={formData.backgroundVerificationConsent || false}
              onChange={handleCheckboxChange}
            />
          }
          label="Background Verification Consent"
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Any Prior Legal/Regulatory Issues?"
          name="priorLegalRegulatoryIssues"
          value={formData.priorLegalRegulatoryIssues || ''}
          onChange={handleChange}
          select
        >
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>
      </Grid>
      {formData.priorLegalRegulatoryIssues === 'Yes' && (
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Provide Details"
            name="priorLegalRegulatoryDetails"
            value={formData.priorLegalRegulatoryDetails || ''}
            onChange={handleChange}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default ComplianceVerification;